import React, { useState } from 'react';
import { Form, Button, Card } from 'react-bootstrap';

const FileEdit = ({ file, onUpdateFile, onCancel }) => {
    const [editedFile, setEditedFile] = useState(file);

    const handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setEditedFile({ ...editedFile, [e.target.name]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        onUpdateFile(editedFile);
    };

    return (
        <Card>
            <Card.Body>
                <Form onSubmit={handleSubmit}>

                    <Form.Group className="mb-3">
                        <Form.Label>File Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={editedFile.name}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Visibility</Form.Label>
                        <Form.Select
                            name="visibility"
                            defaultValue={editedFile?.visibility || 'private'}
                            onChange={handleChange}
                        >
                            <option value="private">Private</option>
                            <option value="global">Global</option>
                        </Form.Select>
                    </Form.Group>
                    <br></br>
                    <Button variant="primary" type="submit" className="mr-2">
                        Update File
                    </Button>
                    <Button variant="secondary" onClick={onCancel}>
                        Cancel
                    </Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default FileEdit;